$(document).ready(function () {

    // TODO: make default item for empty result;

    const action = {},
        tabs = {};
    tabs.modules = $('[data-tabs]');
    tabs.headClass = 'tabs__head-item';
    tabs.headSelector = '.' + tabs.headClass;
    tabs.contentClass = 'tabs__content-item';
    tabs.contentSelector = '.' + tabs.contentClass;
    tabs.headActiveClass = 'tabs__head-item_active';
    tabs.headActiveSelector = '.' + tabs.headActiveClass;
    tabs.contentActiveClass = 'tabs__content-item_active';
    tabs.contentActiveSelector = '.' + tabs.contentActiveClass;

    action.init = module => {

        if (module.data('tabs-construct')) action.construct(module);
        action.addEvents(module);

    };

    action.construct = module => {

        var activeTab = module.find('[data-tabs-default]').length ? module.find('[data-tabs-default]') : module.find(tabs.headSelector).eq(0);
        action.click(activeTab);

    };

    action.filter = {};
    action.filter.delegate = (module, type) => {

        if (type === 'slick') {
            action.filter.slick(module);
        } else {
            action.filter.default(module);
        }

    };

    action.filter.slick = (module) => {

        const moduleValue = module.find(tabs.headActiveSelector).data('tabs-value'),
            filterTarget = $(module.data('tabs-filter'));

        filterTarget.slick('slickUnfilter');
        if (moduleValue?.length)
            filterTarget.slick('slickFilter', '[data-tabs-value="' + moduleValue + '"]');

    };

    action.filter.default = (module) => {

        const moduleValue = module.find(tabs.headActiveSelector).data('tabs-value'),
            filterTarget = module.data('tabs-filter') ? $(module.data('tabs-filter')) : module.find('.tabs__content');

        filterTarget.find(tabs.contentActiveSelector).removeClass(tabs.contentActiveClass);

        if (moduleValue?.length)
            filterTarget.find('[data-tabs-value="' + moduleValue + '"]').addClass(tabs.contentActiveClass);

    };

    action.click = (tab) => {

        const module = tab.parents('[data-tabs]'),
            filterType = module.data('tabs-filter-type');

        if (tab.data('tabs-prevent')) return;

        module.find(tabs.headActiveSelector).removeClass(tabs.headActiveClass);
        tab.addClass(tabs.headActiveClass);

        action.filter.delegate(module, filterType);
        action.checkInput(module);

    };

    action.checkInput = (module) => {

        const input = module.find('[name="' + module.data('tabs-input') + '"]'),
            value = module.find(tabs.headActiveSelector).length ? module.find(tabs.headActiveSelector).data('tabs-input-value') : '';

        if (input.length) input.val(value).trigger('change');

    };

    action.addEvents = (module) => {

        module.on('click', tabs.headSelector, function () {
            action.click($(this));
        });

    };

    action.change = (module) => {

        action.click(module.find(tabs.headActiveSelector));

    };

    tabs.modules.each((i, e) => action.init($(e)));

});
